/* eslint-disable no-unused-vars */

import axios from "axios";
import * as CONFIG from "../../config";

const endpoints = {
    obtainJWT: "/api-token-auth/",
    verifyJWT: "/api-token-verify/",
    refreshJWT: "/api-token-refresh/",
    expireJWT: "/api-token-expire/",

    getPermissions: "/api/ocom/my_group_permissions/",

    baseUrl: process.env.VUE_APP_ROOT_API || "",
};

// send login data and retrive a new token
export const postLogin = ({ username, password }) => {
    return new Promise((resolve, reject) => {
        axios
            .post(endpoints.baseUrl + endpoints.obtainJWT, {
                username: username,
                password: password,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getPermissions = (token) => {
    return new Promise((resolve, reject) => {
        var headers = { Authorization: "bearer " + token };

        axios
            .post(
                endpoints.baseUrl + endpoints.getPermissions,
                {},
                { headers: headers }
            )
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const refreshToken = (token) => {
    return new Promise((resolve, reject) => {
        var data = {
            token: token,
        };

        axios
            .post(endpoints.baseUrl + endpoints.refreshJWT, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

// revoke current token
export const revokeToken = () =>
    axios.post(endpoints.baseUrl + endpoints.expireJWT, {});

export const loadUserData = () => {
    return new Promise((resolve, reject) => {
        resolve();
    });
};

export const isAuthDisabled = () => {
    if ("authDisabled" in CONFIG) {
        return !!CONFIG.authDisabled;
    }

    return false; // not disabled
};
